<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
    import {Tabbar, TabbarItem} from 'vant';
    export default {
        name: 'Main',
        components: {
            Tabbar,
            TabbarItem
        },
        methods:{
            switchTab:function(e){
                this.active =   e;
            }
        },
        data() {
            return {
                active:1
            }
        },
        watch: {
            active(newValue, oldValue) {
                console.log(newValue)
            }
        },
        mounted(options) {
            this.$nextTick(() => {
                var currentUrl = window.location.pathname
                if(currentUrl == '/uc'){
                  this.active = 2
                }else{
                  this.active = 1
                }
            })

        }
    }
</script>
